import React, { Component } from 'react';
import _ from 'lodash';

import CityTable from '../components/CityTable';
import CityForm from '../components/CityForm';

import CityModel from '../components/CityModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class SettingsCitiesScreen extends Component {

    state = {
        dataLoading: true,
        dataAll: [],
        data: [],
        cityFormModalVisible: false,
        cityFormDefaultValues: null,
    }

    componentWillMount() {
        this.loadData();
    }

    loadData(force = false) {
        this.setState({
            dataLoading: true
        });
        CityModel.getAll(force)
            .then(data => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data
                });
            });
    }

    onSearch(searchText) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => { return d['Name'].startsWith(searchText); })
        })
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0' }}>
                <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <h2>Systém - Seznam měst</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={8}>
                                <Input.Search
                                    placeholder="Název města"
                                    onSearch={this.onSearch.bind(this)}
                                    style={{ width: 300 }} />
                            </Col>
                            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                                <Button type="default" onClick={() => { this.loadData(true) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                                {UserModel.isInRoles(['ADMIN', 'CORE_CITIES_WRITE'])
                                    ? <Button type="default" onClick={() => { this.setState({ cityFormModalVisible: true }) }}>Nové město</Button>
                                    : null}
                            </Col>
                        </Row>
                    </div>
                    <CityForm
                        type="modal"
                        modalVisible={this.state.cityFormModalVisible}
                        defaultValues={this.state.cityFormDefaultValues}
                        onModalCancel={(form) => {
                            form.resetFields();
                            this.setState({
                                cityFormModalVisible: false,
                                cityFormDefaultValues: null
                            });
                        }}
                        onSuccess={(form, values) => {
                            CityModel.create(values)
                                .then(() => {
                                    message.success("Město bylo vloženo!");
                                    form.resetFields();
                                    this.loadData(true);
                                });
                        }} />
                    <CityTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onDetailRow={(record) => {
                            this.setState({
                                cityFormModalVisible: true,
                                cityFormDefaultValues: record
                            });
                        }}
                        onRemoveRow={(id) => {
                            CityModel.remove(id)
                                .then(() => {
                                    this.loadData(true);
                                });
                        }}
                        onAnyFormSuccess={() => {
                            this.loadData(true);
                        }} />
                </div>
            </Layout.Content>
        );
    }
}

export default SettingsCitiesScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsCitiesScreen.js